export function trimFormValues<T extends Record<string, unknown>>(values: T, excludeKeys: string[] = []): T {
  return Object.entries(values).reduce((acc, [key, value]) => {
    if (excludeKeys.includes(key)) {
      acc[key] = value
    } else if (typeof value === 'string') {
      acc[key] = value.trim()
    } else if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      acc[key] = trimFormValues(value as Record<string, unknown>, excludeKeys)
    } else {
      acc[key] = value
    }
    return acc
  }, {} as Record<string, unknown>) as T
}
